// Library methods
import React, { useState, useRef } from "react";

// Components
import { TextField, IconButton, Tooltip, Box } from "@mui/material";
import {
  Auth0Icon,
  CancelIcon,
  PlusIcon,
  SearchIcon,
  TrashIcon,
} from "../../../assets/icons";

// Styles
import {
  CustomIconButtonDark,
  CustomIconButtonGray,
} from "../../../styles/muiStylesHelper";

const ActionableSearchBar = ({
  placeholder,
  onSearchChange = () => {},
  disableSearchButton = false,
  onClear = () => {},
  initialExpanded = false,
  selectedRows = [],
  showDeleteButton = false,
  disableDeleteButton = false,
  deleteButtonOnClick = () => {},
  showAuth0Button = false,
  auth0ButtonOnClick = () => {},
  showAddButton = false,
  addButtonOnClick = () => {},
  showFilterInput = true,
  addTooltip = undefined,
  searchTooltip = undefined,
}) => {
  const [expandSearchInput, setExpandSearchInput] = useState(initialExpanded);
  const inputRef = useRef(null);

  const clearSearchFilter = () => {
    if (onClear) onClear();
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {showFilterInput && (
        <>
          {expandSearchInput && (
            <TextField
              autoFocus
              placeholder={placeholder}
              inputRef={inputRef}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                style: {
                  backgroundColor: "#EFEFEF",
                  color: "#202338",
                  height: 40,
                  border: "1px solid #202338",
                  borderRadius: "4px",
                },
                startAdornment: (
                  <Box sx={{ display: "flex", alignItems: "center", mx: 1 }}>
                    <SearchIcon />
                  </Box>
                ),
                endAdornment: (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mx: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      clearSearchFilter();
                      setExpandSearchInput(false);
                    }}
                    data-testid="reset-button"
                  >
                    <CancelIcon />
                  </Box>
                ),
              }}
              data-testid="search-box"
              onChange={(e) => onSearchChange?.(e)}
              sx={{ width: { sm: 200, md: 150, lg: 250 }, mb: 0 }}
            />
          )}

          {!expandSearchInput && !disableSearchButton && (
            <Tooltip title={searchTooltip}>
              <IconButton
                data-testid="search-icon"
                aria-label="search"
                sx={CustomIconButtonDark}
                disabled={disableSearchButton}
                onClick={() => {
                  if (expandSearchInput) clearSearchFilter();
                  setExpandSearchInput((prev) => !prev);
                }}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}

      {showAddButton && (
        <Tooltip title={addTooltip}>
          <IconButton
            aria-label="add"
            sx={CustomIconButtonDark}
            onClick={addButtonOnClick}
          >
            <PlusIcon />
          </IconButton>
        </Tooltip>
      )}

      {Boolean(showAuth0Button) && (
        <IconButton
          aria-label="auth0-icon-button"
          sx={CustomIconButtonDark}
          onClick={auth0ButtonOnClick}
        >
          <Auth0Icon />
        </IconButton>
      )}

      {selectedRows.length > 0 && showDeleteButton && (
        <Tooltip
          title="Delete selected items"
          disableHoverListener={!disableDeleteButton}
        >
          <span>
            <IconButton
              data-testid="delete-icon"
              aria-label="delete"
              sx={CustomIconButtonGray}
              disabled={disableSearchButton || disableDeleteButton}
              onClick={deleteButtonOnClick}
            >
              <TrashIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
  );
};
export default ActionableSearchBar;
